import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5068d750"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContactForm: require('/vercel/path0/components/contactForm.vue').default,Cta: require('/vercel/path0/components/ui/cta.vue').default,Link: require('/vercel/path0/components/ui/link.vue').default})
